import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Home from "./pages/Home";
import About from "./pages/About";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import { Login, Signup, AuthCallback } from "./pages/Auth";
import MyOrders from "./pages/MyOrders";
import AdminDashboard from "./pages/AdminDashboard";
import PickList from "./pages/PickList";
import SetupWizard from "./pages/SetupWizard";
import StoreSettings from "./pages/StoreSettings";

function Router() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback/>;
  return (
    <>
      <Nav/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/shop" element={<Shop/>}/>
        <Route path="/product/:id" element={<ProductDetail/>}/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/checkout" element={<Checkout/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/signup" element={<Signup/>}/>
        <Route path="/orders" element={<MyOrders/>}/>
        <Route path="/admin" element={<AdminDashboard/>}/>
        <Route path="/admin/picklist" element={<PickList/>}/>
        <Route path="/admin/setup" element={<SetupWizard/>}/>
        <Route path="/admin/settings" element={<StoreSettings/>}/>
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AppProvider>
          <Router/>
          <Toaster position="top-right"/>
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}
